import axiosApi from '../../../../axios/axios-api'

export const setPatient = ({ commit }, payload) => {
  commit('setPatient', payload)
}
export const setPatients = ({ commit }, payload) => {
  commit('setPatients', payload)
}
export const fetchPatientsByNroDoc = ({ commit }, nroDoc) => {
  return new Promise((resolve, reject) => {
    axiosApi.get(`Pacientes/Documento/${nroDoc}`).then((response) => {
      var responseData = response.data
      var patients = responseData.data
      commit('setPatients', patients)
      resolve()
    })
  })
}
